
<template>
  <el-card>
    <Base/>
  </el-card>
</template>

<script>
import Base from './Base.vue'
export default {
  name: 'List',
  components: {
    Base
  },
  data () {
    return {
    }
  },
  computed: {
  },
  created () {
  },
  methods: {
  }
}
</script>

<style scoped lang="scss">
</style>
